import { useContext } from 'react';
import AvailabilityError from '~/constants/availabilityError';
import UserVehicleContext, {
  useVehicleAvailability
} from '~/context/vdp/UserVehicleContext';
import useIsReservableVehicle from './useIsReservableVehicle';

export default function useAlertStatus() {
  const { hasError } = useContext(UserVehicleContext).vehicleAvailability;
  const { error: alertToShow } = useVehicleAvailability();
  const isReservable = useIsReservableVehicle();

  const purchasePending = alertToShow === AvailabilityError.PurchasePending;
  const unavailable = alertToShow === AvailabilityError.Unavailable;
  const stopSaleRecall = alertToShow === AvailabilityError.StopSaleRecall;
  const outOfMarket = alertToShow === AvailabilityError.OutOfMarket;
  const isSold = alertToShow === AvailabilityError.IsSold;
  const notAvailableInCA = alertToShow === AvailabilityError.NotAvailableInCA;
  const isReservableAndPurchasePending = isReservable && purchasePending;

  const showAlert =
    !hasError &&
    alertToShow !== AvailabilityError.None &&
    alertToShow !== AvailabilityError.OnSitePrivate &&
    alertToShow !== AvailabilityError.UnavailableReserved &&
    !isReservableAndPurchasePending &&
    !purchasePending;

  return {
    purchasePending,
    unavailable,
    stopSaleRecall,
    outOfMarket,
    isSold,
    showAlert,
    notAvailableInCA
  };
}
